const Footer = () => {
    return (
        <div className={"row foot"}>
            <div id={"gradient_1"}/>
            <div id={"bottom_blue"}/>
        </div>
    );
};

export default Footer;